import { helpers } from 'vuelidate/lib/validators'
import moment from 'moment'

export default date =>
  helpers.withParams(
    { type: 'minDate', min: date },
    function(value, parentVm) {
        var endDt = null
        if (date === ">" && date && parentVm && parentVm.startDate){
            endDt = moment(parentVm.startDate).format("YYYY-MM-DD")
        }
        var input = moment(moment(value).format("YYYY-MM-DD"))
        var reference
        if (!endDt) {
            reference = moment(moment(date).format("YYYY-MM-DD"))
        } else {
            reference = moment(endDt)
        }
        return !helpers.req(value) || input >= reference
    }
  )